import StepTemplate from './Step_template'
import RechnerHintCol from './Rechner_Hint_Col'
import RechnerFieldCol from './Rechner_Field_Col'
import validators from '@/validators'
import AnzeigepflichtBlock from './common/Anzeigepflicht_Block'

// import _ from 'lodash'
// import {withParams} from 'vuelidate/lib/validators'

var slideMixin = {
    //===========================================================================================================
    components: {
        StepTemplate, RechnerHintCol, RechnerFieldCol,AnzeigepflichtBlock
    }, //========================================================================================================
    props: ['activeStepNr', 'myStepNr', 'allSteps', 'value'],
    //===========================================================================================================
    data: function () {

        //default fieldDefs - können in der  konkreten step-Komponenten in 'data{}' überschgrieben/merged werden
        var fieldDefs = this.$store.state.rechnerConfig.fieldDefs

        return {
            fieldDefs: fieldDefs,
            frmValuesOld: {},
        }
    }, //========================================================================================================
    validations: function () {

        var validationDef = this.build_validations(this.$options.fieldKeys, this.fieldDefs)
        console.log("build_validations done")
        return {'value': {fieldValues: validationDef}}
        /*
        this.$validateParams = {}
        var SWITCH = 1
        if (this.forceUpdateDummy || SWITCH === 1) {
          //console.log("+ + + + + + + ", this.$options.fieldKeys)
          var fieldDefs = this.fieldDefs // this.$store.state.rechnerConfig.fieldDefs
          var allFields_validations = {}

          for (var X in this.$options.fieldKeys) {
            var fieldName = this.$options.fieldKeys[X]
            this.$validateParams[fieldName] = {}
            console.log('--> fieldName', fieldName, fieldDefs[fieldName], fieldDefs[fieldName].validate)
            var field_X_validations = {}
            var validateArray = fieldDefs[fieldName].validate
            var test = 0
            if (validateArray.length === 0) {
              test = 1
              field_X_validations = {'noValidation': validators['noValidation']};
            } else {
              for (var validFunctionName in validateArray) {
                var params = validateArray[validFunctionName]
                if (!params) {
                  test = 2
                  field_X_validations[validFunctionName] = validators[validFunctionName]
                } else {
                  test = 3
                  field_X_validations[validFunctionName] = validators[validFunctionName](params)
                  this.$validateParams[fieldName][validFunctionName] = params
                }
                console.log("(" + test + ")", fieldName, "=> ", validFunctionName, params)
              }
            }
            allFields_validations[fieldName] = field_X_validations;
          }
        }
        console.log("- - - - - - - - - -  ", this.$options.fieldKeys, allFields_validations)
        return {'value': {fieldValues: allFields_validations}}
        */
    }, //========================================================================================================

    computed: {
        //————————————————————————————————————————————————————————————————————————————————
        frmHasErros: function () {
            return this.$v.$error
        }, //—————————————————————————————————————————————————————————————————————————————
        frmIsValid:

            function () {
                return !this.$v.$invalid
            }, //—————————————————————————————————————————————————————————————————————————————
        label: function () {
            return this.$options.label
        }, //—————————————————————————————————————————————————————————————————————————————
        isActive: function () {
            console.log('ACTIVE ?', this.$options.label, this.activeStepNr, this.myStepNr)

            return this.activeStepNr && (this.activeStepNr === this.myStepNr)
        }
        , //—————————————————————————————————————————————————————————————————————————————

    }, //========================================================================================================
    methods: {
        testFillForm: function () {
            console.log('mööööp')
            for (var key in this.value.fieldValues) {
                var fD = this.fieldDefs[key]
                var val = this.$store.state.testData[key]
                if (val || val === 0) {
                    console.log('check:', key, '=>', val)
                    if (fD.input_type === 'radio') {
                        console.log('is radio')
                        val = val.toString()
                    }
                    //this.frmValuesOld[key] = val
                    this.value.fieldValues[key] = val
                    console.log('SET Testdaten for "' + key + '"',val)
                    this.value.fieldValues[key] = val

                    if (key === 'reifen_tarif_modell') {
                        var tempKey = key
                        var tempVal = val
                        this.$nextTick(function () {
                            this.value.fieldValues[tempKey] = tempVal
                            console.log('XXX Testdaten for "reifen_tarif_modell"',tempVal)
                        })
                    }
                }
            }


            console.log("**  AUTO FILL **", this.$children[0].$children)
            this.testFillForm_focus_blur_recursive(this.$children[0].$children, 0, 'step')


        }, //______________________________________________________________________________________________
        testFillForm_focus_blur_recursive: function (children, level, lastCompPath) {
            for (var index in children) {
                var comp = children[index]
                var compPath = lastCompPath + " -> " + comp.$options._componentTag
                if (comp.fielddef) {
                    var input = comp.$refs.input
                    if (input) {
                        input.focus()
                        input.blur()
                        console.log(level + ") hit: ", compPath, comp.fielddef.name)
                    }
                } else {
                    if (comp.$children.length > 0 && level < 100) {
                        //console.log(level + "->go deeper ..bubble down", comp.$children.length)
                        this.testFillForm_focus_blur_recursive(comp.$children, level + 1, compPath)
                    } else {
                        console.log(level + "->skip ..bubble back")
                    }

                }
            }

        }, //______________________________________________________________________________________________
        update_Ort_by_PLZ: function (key) {
            var fieldDef = this.fieldDefs[key]
            //console.log('@ @ @ @ @ @ check exists property plz', fieldDef.validate, key,this.value.fieldValues)
            if (fieldDef.validate.hasOwnProperty('plz')) {
                var fieldNameOrt = fieldDef.name.replace('plz', 'ort')
                if (this.value.fieldValues[key] && this.value.fieldValues[key].length === 5) {


                    //console.log("@ @ @ @ @ @ test", fieldNameOrt, this.value.fieldValues[key])
                    if (this.value.fieldValues.hasOwnProperty(fieldNameOrt)) {
                       // console.log('@ @ @ @ @ @ OKI', fieldNameOrt)

                        var url = 'https://api.zippopotam.us/de/' + this.value.fieldValues[key]
                        this.$http.get(url).then(response => {
                            console.log('PLZ-Check response:', response.body)
                            var data = response.body
                            var options = []
                            for (var index in data.places) {
                                var place = data.places[index]
                                console.log('place ', place)

                                options.push({
                                    shortText: null,
                                    text: place['place name'],
                                    value: place['place name'],
                                    value_1914: null,
                                })
                            }
                           // console.log('@ @ @ @ @ @ new options', options)
                            this.fieldDefs[fieldNameOrt].selectOptions = options
                            this.value.fieldValues[fieldNameOrt] = data.places[0]['place name']
                        }, response => {
                            console.log('IBAN DATA ! ERROR ! :', response)

                        })
                    }
                } else {
                    this.fieldDefs[fieldNameOrt].selectOptions = [
                        {
                            shortText: null,
                            text: '(PLZ hat keinen Ortsnamen)',
                            value: '(PLZ hat keinen Ortsnamen)',
                            value_1914: null,
                        }
                    ]
                    this.value.fieldValues[fieldNameOrt] = '(PLZ hat keinen Ortsnamen)'
                }
            }
        }, //______________________________________________________________________________________________
        build_validations: function (fieldKeys, allFieldDefs) {
            this.$validateParams = {}
            var SWITCH = 1
            if (this.forceUpdateDummy || SWITCH === 1) {
                //console.log("+ + + + + + + ", fieldKeys)
                var allFields_validations = {}

                for (var X in fieldKeys) {
                    var fieldName = fieldKeys[X]
                    this.$validateParams[fieldName] = {}
                    console.log('--> fieldName', fieldName, allFieldDefs[fieldName], allFieldDefs[fieldName].validate)
                    var field_X_validations = {}
                    var validateArray = allFieldDefs[fieldName].validate
                    var test = 0
                    if (validateArray.length === 0) {
                        test = 1
                        field_X_validations = {'noValidation': validators['noValidation']}
                    } else {
                        for (var validFunctionName in validateArray) {
                            var params = validateArray[validFunctionName]
                            if (!params) {
                                test = 2
                                field_X_validations[validFunctionName] = validators[validFunctionName]
                            } else {
                                test = 3
                                field_X_validations[validFunctionName] = validators[validFunctionName](params)
                                this.$validateParams[fieldName][validFunctionName] = params
                            }
                            console.log('(' + test + ')', fieldName, '=> ', validFunctionName, params)
                        }
                    }
                    allFields_validations[fieldName] = field_X_validations
                }
            }
            console.log('- - - - - - - - - -  ', fieldKeys, allFields_validations)
            return allFields_validations

        },
    },
    //==========================================================================================================
    //HOOKS:
    mounted() {
        // console.log('slide READY MIXIN ');
        /*
        for (var key in this.$validateParams) {
          for (var validatorKey in this.$validateParams[key]) {
            console.log('00000000000000000 ', key, validatorKey, this.$validateParams[key][validatorKey])
          }
        }
        */
        this.value.$v = this.$v.value.fieldValues

    }
    , //——————————————————————————————————————————————————————————————————————————————————————————————————————

// ========================================================================================================
}

export default slideMixin
